import { Injectable } from '@angular/core';
import { ObservationVariableItem } from '../../shared/models/observation-variable-item.model';
import { StudyInstanceModel } from '../../../shared/dataset/model/study-instance.model';
import { ObservationVariable } from '../../../shared/model/observation-variable.model';
import { StudyDetails } from '../../../shared/study/model/study-details.model';
import { TreatmentFactorLabelInstance } from './treatment-factors.model';

@Injectable({ providedIn: 'root' })
export class ExperimentalDesignContext {
    optionalDesignVariables: ObservationVariableItem[];
    datasetInstances: StudyInstanceModel[];
    totalGermplasmEntryListCount: number;
    entryDetailSettingsMap: Map<number, ObservationVariable>;
    studyDetails: StudyDetails;
    excludedtreatmentFactors: TreatmentFactorLabelInstance[];
}
